import { render, staticRenderFns } from "./GerenciarAcoes.vue?vue&type=template&id=4780b716&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarAcoes.vue?vue&type=style&index=0&id=4780b716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780b716",
  null
  
)

export default component.exports